import Reveal from "@/components/site/Reveal";
import { useContent } from "@/context/ContentContext";

export default function Galleria() {
  const { galleria } = useContent();

  return (
    <section id="galleria" data-testid="galleria-section" className="py-24 lg:py-32 bg-sand-100 noise-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-terracotta-600 mb-4 block">
            {galleria.overline}
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight text-olive-900 max-w-2xl leading-tight">
            {galleria.heading}
          </h2>
        </Reveal>
        <div className="mt-16 columns-1 sm:columns-2 lg:columns-3 gap-6">
          {galleria.items.map((item, i) => (
            <Reveal key={item.caption + i} delay={0.06 * i} className="mb-6 break-inside-avoid">
              <figure className="gallery-item overflow-hidden">
                <div className="overflow-hidden">
                  <img
                    data-testid={`gallery-img-${i}`}
                    src={item.src}
                    alt={item.alt}
                    loading="lazy"
                    className={`gallery-img w-full object-cover ${item.ratio}`}
                  />
                </div>
                <figcaption className="mt-3 text-xs font-medium tracking-[0.18em] uppercase text-stone-500">
                  {item.caption}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
